(function (root) {
  'use strict';

  var cache = { products: null, live: {} };

  function getAll(jsonUrl) {
    if (cache.products) return Promise.resolve(cache.products);
    return fetch(jsonUrl)
      .then(function (res) {
        if (!res.ok) throw new Error('sb-product-data.json fetch failed: ' + res.status);
        return res.json();
      })
      .then(function (data) {
        cache.products = data.products || [];
        return cache.products;
      });
  }

  function getLive(handle) {
    if (cache.live[handle]) return Promise.resolve(cache.live[handle]);
    return fetch('/products/' + handle + '.js')
      .then(function (res) {
        if (!res.ok) throw new Error('Live product fetch failed for ' + handle + ': ' + res.status);
        return res.json();
      })
      .then(function (data) {
        var variant = data.variants && data.variants[0];
        var live = {
          handle: handle,
          title: data.title,
          url: data.url,
          image: data.featured_image || (data.images && data.images[0]) || null,
          price: variant ? variant.price : data.price,
          available: variant ? variant.available : data.available,
          variantId: variant ? variant.id : null,
          variants: data.variants || []
        };
        cache.live[handle] = live;
        return live;
      });
  }

  root.SBProductData = { getAll: getAll, getLive: getLive };
})(window);
